export default __webpack_public_path__ + "static/media/plusblue.11b150b9.svg";